import React from 'react';

interface SettingsOverviewProps {
  configuredProvidersCount: number;
  hasOpenAIAdmin: boolean;
  hasAnthropic: boolean;
  keyCreatedAt?: number;
}

const formatDate = (timestamp: number) => {
  return new Date(timestamp).toLocaleString('en-US');
};

export const SettingsOverview: React.FC<SettingsOverviewProps> = ({
  configuredProvidersCount,
  hasOpenAIAdmin,
  hasAnthropic,
  keyCreatedAt
}) => {
  return (
    <div className="mb-4 rounded-lg border border-gray-200 dark:border-gray-700 bg-gradient-to-r from-gray-50 via-white to-blue-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 px-3 sm:px-4 py-3">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <h3 className="text-sm font-semibold text-gray-900 dark:text-white">Settings Overview</h3>
          <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">
            Configure provider keys and dashboard behavior from one place.
          </p>
          {hasOpenAIAdmin && keyCreatedAt && (
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
              OpenAI Admin key saved: {formatDate(keyCreatedAt)}
            </p>
          )}
        </div>
        <div className="grid grid-cols-3 gap-2 text-center">
          <div className="rounded-md border border-gray-200 dark:border-gray-700 bg-white/80 dark:bg-gray-800/80 px-3 py-2">
            <div className="text-base font-semibold text-gray-900 dark:text-white">{configuredProvidersCount}</div>
            <div className="text-[11px] text-gray-500 dark:text-gray-400">Configured</div>
          </div>
          <div className="rounded-md border border-gray-200 dark:border-gray-700 bg-white/80 dark:bg-gray-800/80 px-3 py-2">
            <div className="text-base font-semibold text-gray-900 dark:text-white">{hasOpenAIAdmin ? 'ON' : 'OFF'}</div>
            <div className="text-[11px] text-gray-500 dark:text-gray-400">OpenAI Admin</div>
          </div>
          <div className="rounded-md border border-gray-200 dark:border-gray-700 bg-white/80 dark:bg-gray-800/80 px-3 py-2">
            <div className="text-base font-semibold text-gray-900 dark:text-white">{hasAnthropic ? 'ON' : 'OFF'}</div>
            <div className="text-[11px] text-gray-500 dark:text-gray-400">Anthropic Admin</div>
          </div>
        </div>
      </div>
    </div>
  );
};
